module.exports = "static/assets/85f62e9e77bed58778782e6cce58c1f4.svg";